import { generateRandomId } from './generate-random-id';

/**
 * Generates a random id to the given element if needed, then returns its id
 * @param element
 * @returns
 */
export function getElementId(element: Element): string {
  if (!element.getAttribute('id')?.trim()) {
    element.setAttribute('id', generateRandomId());
  }

  return element.getAttribute('id') as string;
}
